interface IconProps {
  className?: string;
}

const ROSE_FROM = "#f2c8c2";
const ROSE_TO = "#e8b3ad";

const RoseGradient = ({ id }: { id: string }) => (
  <defs>
    <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stopColor={ROSE_FROM} />
      <stop offset="100%" stopColor={ROSE_TO} />
    </linearGradient>
  </defs>
);

/** Retail — casa / galpón (pentágono) */
export const RetailIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden focusable="false">
    <RoseGradient id="rose-retail" />
    <path
      className="fill-current group-hover/nav:fill-[url(#rose-retail)]"
      d="M0 38 L50 6 L100 38 V100 H0 Z"
    />
  </svg>
);

/** Industrial — fábrica de tres cantos (dientes de sierra) */
export const IndustrialIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden focusable="false">
    <defs>
      <linearGradient id="gold-industrial" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#eae1bd" />
        <stop offset="100%" stopColor="#ddd2a6" />
      </linearGradient>
    </defs>
    <path
      className="fill-current group-hover/nav:fill-[url(#gold-industrial)]"
      d="M0 34 L33 10 V34 L66 10 V34 L100 10 V100 H0 Z"
    />
  </svg>
);


/** Medical — bloque con torre (chimenea) */
export const MedicalIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden focusable="false">
    <defs>
      <linearGradient id="green-medical" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#c9f7d1" />
        <stop offset="100%" stopColor="#a8ecb6" />
      </linearGradient>
    </defs>
    <path
      className="fill-current group-hover/nav:fill-[url(#green-medical)]"
      d="M34 4 H66 V32 H100 V100 H0 V46 H34 Z"
    />
  </svg>
);

export const divisionIcons = {
  retail: RetailIcon,
  industrial: IndustrialIcon,
  medical: MedicalIcon,
};
